<div dir="{{dir}}">
<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
</div>


